// Screen 2 · Home (role-aware). Teacher → This Week + My Classes. Lead → Department Status.
// No pressure counters anywhere (Design Brief).

import { api } from "../api";
import { esc } from "../dom";
import { me, setMe } from "../state";
import { navigate } from "../router";

export function renderHome(app: HTMLElement): void {
  const user = me()!;
  const roleCards =
    user.auth_role === "lead"
      ? `<a class="card" data-link href="/status"><h2>Department Status</h2><p>See who has planned what this week.</p></a>
         <a class="card" data-link href="/insights"><h2>Insights</h2><p>Each teacher's term picture + your tracking notes.</p></a>
         <a class="card" data-link href="/admin"><h2>Accounts</h2><p>Add and manage teacher accounts.</p></a>`
      : `<a class="card" data-link href="/this-week"><h2>This Week</h2><p>Your lessons for this week.</p></a>
         <a class="card" data-link href="/classes"><h2>My Classes</h2><p>The classes you teach.</p></a>`;
  // Dashboard + School Calendar are team-tier — everyone sees them.
  const cards = `${roleCards}
    <a class="card" data-link href="/dashboard"><h2>Dashboard</h2><p>This week's deadlines and the team's projects.</p></a>
    <a class="card" data-link href="/calendar"><h2>School Calendar</h2><p>Term dates, tests, and school events.</p></a>`;

  app.innerHTML = `
    <div class="topbar">
      <span class="muted">Hello, ${esc(user.name)}.</span>
      <a href="#" id="out" class="muted">Sign out</a>
    </div>
    <h1>EDEN</h1>
    ${cards}`;

  app.querySelector<HTMLElement>("#out")!.addEventListener("click", async (e) => {
    e.preventDefault();
    await api("/api/auth/signout", { method: "POST" });
    setMe(null);
    navigate("/signin");
  });
}
